var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"id":"pageContainer"}},[_c('div',{staticClass:"pdfViewer",attrs:{"id":"viewer"}})])
}]

export { render, staticRenderFns }